export type AdminNotification = {
  id: string;
  type: string;
  message: string;
  meta?: Record<string, any>;
  createdAt: number;
};

const STORAGE_KEY = 'adminNotifications';
const MAX_NOTIFICATIONS = 200;

const isBrowser = typeof window !== 'undefined';

const loadNotifications = (): AdminNotification[] => {
  if (!isBrowser) return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const saveNotifications = (items: AdminNotification[]) => {
  if (!isBrowser) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_NOTIFICATIONS)));
  } catch {
    // ignore storage errors
  }
};

export const addAdminNotification = (type: string, message: string, meta?: Record<string, any>) => {
  const now = Date.now();
  const id = `${type}-${now}-${Math.random().toString(36).slice(2)}`;
  const current = loadNotifications();
  const next: AdminNotification[] = [{ id, type, message, meta, createdAt: now }, ...current].slice(
    0,
    MAX_NOTIFICATIONS
  );
  saveNotifications(next);
};

export const getAdminNotifications = (): AdminNotification[] => loadNotifications();

export const clearAdminNotifications = () => {
  saveNotifications([]);
};
